import { render, staticRenderFns } from "./noticeDetail.vue?vue&type=template&id=d6198010&scoped=true"
import script from "./noticeDetail.vue?vue&type=script&lang=js"
export * from "./noticeDetail.vue?vue&type=script&lang=js"
import style0 from "./noticeDetail.vue?vue&type=style&index=0&id=d6198010&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6198010",
  null
  
)

export default component.exports